import React, { Component } from 'react'
import { Row, Col, Button, Input, Icon } from 'react-materialize'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'



class AgeSelector extends Component {
  constructor(props){
    super(props);
    this.onChangeAge = this.onChangeAge.bind(this)
  }

  onChangeAge(val){
    const { age, onChangeAge = () => {} } = this.props
    // if(age.length === 1 || age[0] === val){
    //    alert("Must select at 1 age group")
    //  } else {
        this.props.onChangeAge(val);
    //}
    //else {
    //   if( age.includes(val)){
    //     this.props.onChangeAge(val)
    //   } else {
    //     alert("Maximum two age groups")
    //   }
    // }
  }


    render(){
      const { age, allAges } = this.props;
        return (
          <Row>
            {
              allAges.map( collection =>
                age.includes(collection)?
                  <div className="age-selector" onClick={()=> this.onChangeAge(collection)}><div className='checked'><FontAwesomeIcon icon="check"/></div>&nbsp;{collection}</div>:
                  <div className="age-selector" onClick={()=> this.onChangeAge(collection)}><div className='unchecked'/>&nbsp;{collection}</div> )
            }
          </Row>
          );
    }
  }



  function mapStateToProps(state){
    return {
      age: state.age,
      allAges: state.allAges
    }
  };

  function mapDispatchToProps(dispatch){
    return {
      onChangeAge: (age) => dispatch({ type: 'ONCHANGEAGE', value: age }),
    }
  }

  export default connect(mapStateToProps, mapDispatchToProps)(AgeSelector);



// WEBPACK FOOTER //
// ./src/components/AgeSelector.js